export default {
        // Your original product data
        googleTV: {
          name: 'K350', // Display name for the button
          faqs: [
             {
                question: 'How do I pair the remote control with the projector?',
                answer: 'First, ensure batteries are installed in the remote. To pair, press and hold the ← and home buttons simultaneously more than three seconds near the projector. A pairing message will appear on the screen once successful.'
              },
              {
                question: 'Why is my projector not connecting to Wi-Fi?',
                answer: 'Ensure your Wi-Fi password is correct and you\'re within range of the router. Restart both the router and projector if the issue persists.'
              },
              {
                question: 'Can I use Bluetooth headphones or speakers with this projector?',
                answer: 'Yes! Go to Settings > Bluetooth, turn it on, and select your Bluetooth device from the list. Make sure your headphones/speakers are in pairing mode.'
              },
              {
                question: 'Can I use this projector without an extra streaming stick?',
                answer: 'Yes! This projector comes with Google TV and built-in Netflix, Prime Video, YouTube, and more. No additional device is needed—just plug in and stream.'
              },
              {
                question: 'How can I log into Netflix, Prime Video, or YouTube?',
                answer: 'From the Google TV home screen, select the app you\'d like to use and log in with your account. For quick access, you can press the dedicated app buttons on the remote control or use voice control to open the app instantly.'
              },
              {
                question: 'The screen looks blurry. How do I adjust the focus?',
                answer: 'This projector supports auto focus. If the image is unclear, use the remote’s Focus button or go to Settings > Display > Focus Adjustment to fine-tune.'
              },
              {
                question: 'How do I update the system or apps?',
                answer: 'Go to Settings > System > About > System Update to check for firmware updates. Apps update automatically via the built-in Google Play Store.'
              },
              {
                question: 'How do I wirelessly connect my iPhone or Android phone to the projector?',
                answer: 'To mirror your phone screen, please open the Google Cast app on the projector and follow the prompts to install the Miracast plugin. This plugin is required for both iOS and Android devices and involve a paid version. For Android users, you can also cast directly via the built-in Google Cast feature. For iOS users, a third-party app that supports Miracast or AirPlay is needed. For the most stable connection, an HDMI adapter is recommended.'
              }
          ]
        },
        // Your new product data
        btRemoteProjector: {
          name: 'W1K', // Display name for the button
          faqs: [
            {
              question: 'How can I do if the image is blurry or out of shape?',
              answer: `
                Please try the following steps:
                <ul>
                  <li class='mt-2'>Adjust the focus by pressing the focus[ +]/[-] button till it shows the correct image.</li>
                  <li class='mt-2'>Place the projector on a flat surface horizontally or vertically. An inclination at any angle may result in blurry displays or uneven colors.</li>
                  <li class='mt-2'>A darker environment is suggested to achieve the best projecting performance.</li>
                  <li class='mt-2'>The best distance is 1.3-2.5m / 42.5inch - 82 inch between the projector and projecting screen/wall.</li>
                  <li class='mt-2'>Ensure the projecting wall or screen is clean and white if possible.</li>
                </ul>
              `
            },
            {
              question: 'How to pair the BT remote control with the projector?',
              answer: '1. Please ensure that the remote control is within 10 cm from the device.<br>2. Press the "Volume -" and “Volume +” buttons on the remote control at the same time until the remote control icon appears on the homepage.'
            },
            {
              question: 'How does the projector connect via Bluetooth?',
              answer: `
                <strong>Output (Connecting to external devices like speakers/headsets):</strong>
                <ol class='mt-2 list-decimal list-inside'>
                  <li>Enter homepage and select "Settings".</li>
                  <li>Choose the corresponding BT device to connect.</li>
                </ol>
                <br>
                <strong>Input (Connecting to a mobile phone, using the projector as a speaker):</strong>
                 <ol class='mt-2 list-decimal list-inside'>
                  <li>Enter homepage and select “My apps", then choose Music-connecting.</li>
                  <li><strong>Tips:</strong> Please always keep on the connection page.</li>
                </ol>
              `
            },
            {
              question: 'Why it prompts that there is no network when entering the Android screen mirroring interface?',
              answer: 'After entering the screen projection assistant, you can perform Android and iOS screen mirroring. Because Android is restricted by Microsoft code, it will display "no network" after entering Android screen mirroring.<br><br><strong>Ps:</strong> This is a normal phenomenon. Android does not need a network for screen mirroring. When you switch from Android mirroring to iOS mirroring or exit, WiFi will automatically re-pair for you (takes about 5-20s).'
            },
            {
              question: 'How to screen mirror iOS devices to the projector?',
              answer: `
                <ol class='list-decimal list-inside'>
                  <li>Please select the projection assistant on the homepage.</li>
                  <li>Go to the iOS MagicCast and Select “Go to Download".</li>
                  <li>After successful download, use the Airplay feature to mirror any iPhone/iPad/Macbook using the same WiFi connection.</li>
                </ol>
              `
            },
            {
              question: 'How to mirror screen Android devices to the projector?',
              answer: `
                <ol class='list-decimal list-inside'>
                  <li>Please select the projection assistant on the homepage.</li>
                  <li>Select “Miracast".</li>
                  <li>Go to your Android device "Settings” and select your WLAN.</li>
                  <li>Activate the Multi-screen/Smart View/Wireless Display function in your Android device, search for the projector (e.g., “w1k”), and click to connect.</li>
                </ol>
              `
            },
            {
              question: 'The video cannot be mirrored. There is sound but no picture, or no sound and no picture.',
              answer: `
                1. Please note that copyrighted videos, such as those from "Amazon Prime", "YouTube”, “Hulu", “Netflix”, “Disney+” or other popular streaming services, cannot be mirrored on the same screen due to DRM (Digital Rights Management) protections. <br><strong>PS:</strong> You can try to play these services through a web browser on your device and mirror the browser tab.
                <br><br>
                2. Is the source resolution too high? (e.g., 4k, 8k) And is the video refresh rate exceeding 60Hz? Please note that the projector only supports up to 60Hz and the video source cannot exceed 1080p.
              `
            }
          ]
        }
      }